import script from "./ButtonAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonAtom.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonAtom.vue?vue&type=style&index=0&id=1d1fb194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1fb194"]])

export default __exports__